import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fileConstructionDigestContainer"
}

import {computed} from "vue";
import {FileConstructionGetters} from "@/store/modules/fileConstruction";
import store from "@/store";


import { defineComponent } from 'vue';
const __default__ = defineComponent(
    {
      name: "FileConstructionDigest"
    }
)


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const currentDigest = computed(() => {
  return store.getters[`fileConstruction/${FileConstructionGetters.getCurrentDigest}`];
})

const getUploadPercentage = (): string => {
  if(typeof currentDigest.value === "undefined"){
    return "0.00%";
  }
  let fileCount =(currentDigest.value.total - currentDigest.value.dirCount) ;
  if(fileCount === 0){
    fileCount = 1;
  }
  let percentage =(currentDigest.value.uploaded /  fileCount)* 100;
  return percentage.toFixed(2) + "%";
}


return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!

  return (_unref(currentDigest))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_text, { type: "success" }, {
          default: _withCtx(() => [
            _createTextVNode("当前筛选条件")
          ]),
          _: 1
        }),
        _createVNode(_component_el_text, { type: "success" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString("\t共 " + _unref(currentDigest).dirCount + "\t个文件夹\t"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_text, { type: "success" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString("\t" + _unref(currentDigest).total - _unref(currentDigest).dirCount + "个文件"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_text, { type: "success" }, {
          default: _withCtx(() => [
            _createTextVNode(" 上传 " + _toDisplayString(_unref(currentDigest).uploaded) + " (" + _toDisplayString(getUploadPercentage()) + ") ", 1)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})